import { render } from "./BaseCreateDialog.vue?vue&type=template&id=500f4730"
import script from "./BaseCreateDialog.vue?vue&type=script&lang=js"
export * from "./BaseCreateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__